/* eslint-disable no-console */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: null,
    userData: null,
    isAdmin: true, //stay true temproraily so all accounts can see admin
    isLoaded: false,
    projectDetails: null,
    allTasksAndSubTasks : false,
    landingPageDetails : false,
    notify: {
      type: "success",
      message: "",
      status: false,
    },
    allTasks: null,
    viewTask: null,
    editTask: null,
    deleteTask: null,
    countries: [],
    regions: [],
  },

  getters: {
    countries(state) {
      return state.countries;
    },
    regions(state) {
      return state.regions;
    }
  },

  actions: {
    viewTask({ commit }) {
      commit("viewTask");
    },
    editTask({ commit }) {
      commit("editTask");
    },
    deleteTask({ commit }) {
      commit("deleteTask");
    },
  },

  mutations: {
    commitItem(state, payload) {
      state[payload.key] = payload.value;
    },

    setToken(state, token) {
      state.token = token;
    },

    setIsAdmin(state, userType) {
      state.isAdmin = userType == 0;
    },

    storeUserData(state, data) {
      state.userData = data;
    },

    setIsLoaded(state, isLoaded) {
      state.isLoaded = isLoaded;
    },

    setProjectDetails(state, project) {
      state.projectDetails = project;
    },

    setNotify(state, notifyParams) {
      state.notify.type = notifyParams.type;
      state.notify.message = notifyParams.message;
      state.notify.status = notifyParams.status;
    },

    allTasks(state, data) {
      state.allTasks = data;
    },

    viewTask(state, data) {
      state.viewTask = data;
    },
    editTask(state, data) {
      state.editTask = data;
    },
    deleteTask(state, data) {
      state.deleteTask = data;
    },
    storeCountries(state, data) {
      state.countries = data;
    },
    storeRegions(state, data) {
      state.regions = data;
    },
  },
});

export { store };
